<div class="page">
  <h1>Redirecting after signin ... Please Wait</h1>
</div>
